import {
	ControlProps,
	IndicatorsContainerProps,
	InputProps,
	MenuListProps,
	MenuProps,
	ValueContainerProps,
	PlaceholderProps,
	DropdownIndicatorProps,
} from "react-select";

export const reactSelectStyles = {
	indicatorSeparator: () => ({
		display: "none",
	}),
	indicatorsContainer: (provided: IndicatorsContainerProps) => ({
		...provided,
		maxHeight: "28px",
	}),
	menuPortal: (base: MenuProps) => ({
		...base,
		zIndex: 99999999999,
	}),
	control: (base: ControlProps) => ({
		...base,
		border: "1px solid #A0AEC0",
		padding: "4px 8px",
	}),
	valueContainer: (base: ValueContainerProps) => ({
		...base,
		padding: "0 6px",
	}),
	input: (base: InputProps) => ({
		...base,
		margin: 0,
		padding: 0,
	}),
	menuList: (base: MenuListProps) => ({
		...base,
		maxHeight: "200px",
	}),
	placeholder: (provided: PlaceholderProps) => ({
		...provided,
		color: "#1A202C",
		fontSize: "14px",
	}),
	dropdownIndicator: (provided: DropdownIndicatorProps) => ({
		...provided,
		fontWeight: "bold",
		padding: 0,
		height: "100%",
		justifyContent: "center",
		alignItems: "center",
		svg: {
			width: "22px",
			height: "22px",
		},
	}),
};
